import React, { Component } from 'react';
import { Divider, Form, Input, TextArea, Button } from 'semantic-ui-react';
import swal from 'sweetalert';
import AWS from 'aws-sdk';

AWS.config = new AWS.Config({
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
    region: process.env.REACT_APP_AWS_REGION
});
const ses = new AWS.SES();

export default class ContactForm extends Component {
    state = {
        name: '',
        email: '',
        message: '',
        loading: false
    };

    handleInput(key, e) {
        let state = this.state;
        state[key] = e.target.value;

        this.setState(state);
    }

    validEmail(email) {
        return /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/.test(email);
    }

    handleSubmit() {
        this.setState({ loading: true });

        const { name, email, message } = this.state;

        const subject = "Message sent it from https://www.luisboscan.com";

        const bodyMessage = `
            ${name} - ${email},

            ${message}
        `;

        const params = {
            Message: {
                Subject: {
                    Data: subject,
                    Charset: 'utf-8'
                },
                Body: {
                    Text: {
                        Data: bodyMessage,
                        Charset: 'utf-8'
                    }
                }
            },
            Destination: {
                ToAddresses: ["luife642@gmail.com"]
            },
            Source: `'${name}' <luife642+webpage@gmail.com>`
        };

        ses.sendEmail(params, (err, data) => {
            if (err) {
                console.log(err);
                swal("Ups something went wrong!", "Try again later please.", "error");
            } else {
                swal("Thanks!", "Message was sent it successfully! I will give you an answer.", "success");
                this.setState({ name: '', email: '', message: '' });
            }
            this.setState({ loading: false });
        });
    }

    render() {
        const { name, email, message, loading } = this.state;

        return (
            <Form>
                <div>
                    <Button onClick={(e) => {
                        window.open('https://www.facebook.com/luis.boscannava', '_blank');
                    }} size={'small'} circular color='facebook' icon='facebook' style={{ margin: '0 5px' }} />
                    <Button onClick={(e) => {
                        window.open('https://twitter.com/lfbos19', '_blank');
                    }} size={'small'} circular color='twitter' icon='twitter' style={{ margin: '0 5px' }} />
                    <Button onClick={(e) => {
                        window.open('https://www.instagram.com/lboscannava/', '_blank');
                    }} size={'small'} circular color='instagram' icon='instagram' style={{ margin: '0 5px' }} />
                    <Button onClick={(e) => {
                        window.open('https://www.linkedin.com/in/lfboscan/', '_blank');
                    }} size={'small'} circular color='linkedin' icon='linkedin' style={{ margin: '0 5px' }} />
                    <Button onClick={(e) => {
                        window.open('https://plus.google.com/+LuisBoscan19', '_blank');
                    }} size={'small'} circular color='google plus' icon='google plus' style={{ margin: '0 5px' }} />
                </div>

                <Divider horizontal />

                <Form.Group widths='equal'>
                    <Form.Field value={name} control={Input} label='Name' placeholder='Your name' onChange={this.handleInput.bind(this, 'name')} />
                    <Form.Field value={email} type={"email"} control={Input} label='Email' placeholder='Your email' onChange={this.handleInput.bind(this, 'email')} error={(() => {
                        if (!email) {
                            return false;
                        }

                        return !this.validEmail(email);
                    })()} />
                </Form.Group>
                <Form.Field value={message} control={TextArea} placeholder='Message' onChange={this.handleInput.bind(this, 'message')} />
                <Button loading={loading} color="blue" disabled={!name || !email || !message || !this.validEmail(email)} onClick={this.handleSubmit.bind(this)}>
                    Send
                </Button>
            </Form>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ContactForm.js